var _ellipse, _ellipse2, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTokenDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 340,
    viewBox: "0 0 341 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.343,
    cy: 170,
    rx: 170.343,
    ry: 170,
    fill: "url(#paint0_linear_223_1039)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.342,
    cy: 170,
    rx: 150.25,
    ry: 149.947,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.832 170C301.832 242.471 242.964 301.223 170.343 301.223C97.7212 301.223 38.8531 242.471 38.8531 170C38.8531 97.5292 97.7212 38.7768 170.343 38.7768C242.964 38.7768 301.832 97.5292 301.832 170Z",
    stroke: "url(#paint1_linear_223_1039)",
    strokeOpacity: 0.5,
    strokeWidth: 1.93
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0929 170C20.0929 130.232 35.9227 92.0919 64.1 63.9713C92.2772 35.8507 130.494 20.0527 170.342 20.0527C210.191 20.0527 248.408 35.8507 276.585 63.9713C304.762 92.0918 320.592 130.232 320.592 170L170.343 170L20.0929 170Z",
    fill: "url(#paint2_linear_223_1039)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.097,
    y: 226.355,
    width: 33.5887,
    height: 33.5887,
    fill: "#8DFCF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170.685,
    y: 226.355,
    width: 33.5887,
    height: 33.5887,
    fill: "#01E8DE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170.685,
    y: 192.766,
    width: 33.5887,
    height: 33.5887,
    fill: "#21CECB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 203.95,
    y: 192.766,
    width: 33.5887,
    height: 33.5887,
    fill: "#01E8DE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 103.508,
    y: 192.68,
    width: 33.5887,
    height: 33.5887,
    fill: "#1AB4B1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 203.95,
    y: 159.177,
    width: 33.5887,
    height: 33.5887,
    fill: "#01E8DE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 103.508,
    y: 159.092,
    width: 33.5887,
    height: 33.5887,
    fill: "#4CFFF7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 203.95,
    y: 125.503,
    width: 33.5887,
    height: 34.59,
    fill: "#4CFFF7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 203.95,
    y: 92,
    width: 33.5887,
    height: 33.5887,
    fill: "#4CFFF7",
    fillOpacity: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 103.508,
    y: 125.503,
    width: 33.5887,
    height: 33.5887,
    fill: "#01E8DE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 103.508,
    y: 92,
    width: 33.5887,
    height: 33.5887,
    fill: "#01E8DE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_223_1039",
    x1: 246.541,
    y1: 246.045,
    x2: 94.4511,
    y2: 93.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59FFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#7CFFF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_223_1039",
    x1: 229.593,
    y1: 229.131,
    x2: 75.8422,
    y2: 59.1903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#5AFFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_223_1039",
    x1: 123.942,
    y1: 178.868,
    x2: 94.5704,
    y2: 27.9863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00382185,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272727"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenDark);
export default __webpack_public_path__ + "static/media/token-dark.f934f125dc668416cda121fbe4828424.svg";
export { ForwardRef as ReactComponent };